module.exports = __webpack_public_path__ + "img/theme-title.35172a5f.png";